<nb-card>
  <nb-card-header i18n="@@Requests">Запросы</nb-card-header>
  <nb-card-body>
    <p>
      <input i18n-placeholder="@@AddSynonymName" [formControl]="inputFormControl" nbInput type="text" fieldSize="small" placeholder="Введите запрос" [nbAutocomplete]="auto"/>
    </p>
    <nb-autocomplete #auto (selectedChange)="insertTerm($event)" [handleDisplayFn]="viewHandle">
      <nb-option *ngFor="let term of terms$ | async" [value]="term">
        {{ term.header }}
      </nb-option>
    </nb-autocomplete>

    <ng-container *ngIf="queries.length">
      <nb-tag-list>
        <nb-tag appearance="outline" status="primary" *ngFor="let term of queries" [text]="term.header" [removable]="true" (remove)="removeTerm(term)"></nb-tag>
      </nb-tag-list>
      <br/><br/>
    </ng-container>

  </nb-card-body>
</nb-card>
